import { Pagination, PaginationItem, useTheme } from "@mui/material";
import React from "react";

export const EGPaginator = ({
  count,
  page,
  onChange,
  showFirstButton = true,
  showLastButton = true,
  boundaryCount = 1,
}) => {
  const theme = useTheme();

  return (
    <Pagination
      count={count}
      page={page}
      onChange={onChange}
      showFirstButton={showFirstButton}
      showLastButton={showLastButton}
      shape="rounded"
      size="small"
      boundaryCount={boundaryCount}
      renderItem={(item) => (
        <PaginationItem
          {...item}
          slots={{
            previous: () => <span style={{ fontSize: "18px" }}>&#8249;</span>,
            next: () => <span style={{ fontSize: "18px" }}> &#8250; </span>,
            first: () => <span style={{ fontSize: "18px" }}>«</span>,
            last: () => <span style={{ fontSize: "18px" }}>»</span>,
          }}
        />
      )}
      sx={{
        "& .MuiPaginationItem-root": {
          fontSize: 9,
          minWidth: "18px",
          height: "18px",
          display: "flex",
          alignItems: "center",
          flexFlow: "row nowrap",
          justifyContent: "space-around",
          mx: 0.2,
        },
        // Only the number buttons have custom styling
        "& .MuiPaginationItem-page": {
          borderRadius: "3px",
          backgroundColor: theme.palette.paleGrey.main,
          color: theme.palette.common.black,
          "&.Mui-selected": {
            backgroundColor: theme.palette.secondary.light,
            border: `1px solid ${theme.palette.blueGray.main}`,
            color: theme.palette.common.white,
            "&:hover": {
              backgroundColor: theme.palette.secondary.dark,
            },
          },
          "&:hover": {
            scale: 1.1,
            backgroundColor: "#D6DADE",
          },
        },
        "& .MuiPaginationItem-previous, & .MuiPaginationItem-next, & .MuiPaginationItem-first, & .MuiPaginationItem-last, & .MuiPaginationItem-ellipsis":
          {
            backgroundColor: "transparent",
            color: "#000",
          },
      }}
    />
  );
};
